import { useTonConnectModal, useTonConnectUI } from '@tonconnect/ui-react'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { AppButton } from '@/shared/ui/button'
import { useStyles } from './styles'
import { useEffect } from 'react'
import { goToMain } from '@/app/routing/events'
import { useHideNav } from '@/shared/hooks/useHideNav'

export const TonConnect = () => {
  useHideNav()
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const { open } = useTonConnectModal()
  const status = useTonConnectUI()[0].connected

  const handleClickPrimary = () => {
    open()
  }

  useEffect(() => {
    if (status) {
      // goToMain()
    }
  }, [status])

  return (
    <div className={classes.root}>
      <div></div>
      <div className={classes.logo}>
        <img
          src="https://storage.yandexcloud.net/gamed/stuff/tonConnect.webp"
          alt=""
        />
      </div>
      <div className={classes.content}>
        <div className={classes.title}>{lang[userLang].pages.tonConnect.title}</div>
        <div className={classes.text}>{lang[userLang].pages.tonConnect.text}</div>
        <AppButton
          onClick={handleClickPrimary}
          sx={{ height: '50px' }}
          variant="primary"
          fullWidth
        >
          <div className={classes.buttonText}>{lang[userLang].pages.tonConnect.button}</div>
        </AppButton>
        <AppButton
          onClick={() => goToMain()}
          sx={{ height: '50px' }}
          variant="transparent"
          fullWidth
        >
          <div className={classes.buttonTextsecond}>{lang[userLang].pages.tonConnect.buttonSecond}</div>
        </AppButton>
      </div>
    </div>
  )
}
